import { ActModuleMenuOptionRoute } from '../../components/features/ActModule/_props'
import { ACT_MODULE_NAVIGATION_TOGGLE, ACT_MODULE_FINISH_TOGGLE } from '../actions/types'

export type ActModuleStoreNavigation = {
    disabled: boolean
    keptAliveItem: ActModuleMenuOptionRoute | undefined
}
interface ActModuleStore {
    navigation: ActModuleStoreNavigation
    isFinishDisabled: boolean
}

const INITIAL_STATE: ActModuleStore = {
    navigation: {
        disabled: false,
        keptAliveItem: undefined,
    },
    isFinishDisabled: false,
}

export default (state = INITIAL_STATE, action: any): ActModuleStore => {
    switch (action.type) {
        case ACT_MODULE_NAVIGATION_TOGGLE:
            return {
                ...state,
                navigation: action.payload,
            }
        case ACT_MODULE_FINISH_TOGGLE:
            return {
                ...state,
                isFinishDisabled: action.payload,
            }
        default:
            return state
    }
}
